// BFF: ○ gap — legacy carePlan endpoints. The care-plans tab has no bff/crm module.
export { default } from './CarePlans'
export { default as CarePlansModal } from './CarePlansModal/CarePlansModal'
export { listCarePlansQueryKey, useCarePlans } from './CarePlanService'
